import { api } from '../utils/axios';

export const getApiConfigs = () => async (dispatch) => {
  
  let data = {};
  dispatch({
    type: "GET_APICONFIG_REQUESTED"
  });
  try {
    const response = await api.post('admin/get_api_configs', data);
    dispatch({
      type: "GET_APICONFIG_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "GET_APICONFIG_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}

export function setDeveloperPageInfo({pageSize,pageNo}){
  return {
    type : 'SET_DEVELOPER_PAGEINFO',
    payload : {pageSize,pageNo }
  }
}

export const deleteApiKey = (apiId) => async (dispatch) => {
  
  let data = {api_Id: apiId};
  dispatch({
    type: "DELETE_APICONFIG_REQUESTED"
  });
  try {
    const response = await api.post('admin/delete_api_configs', data);
    dispatch({
      type: "DELETE_APICONFIG_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "DELETE_APICONFIG_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}

export const createApiKey = (api_config) => async (dispatch) => {
  
  let data = api_config;
  dispatch({
    type: "CREATE_APICONFIG_REQUESTED"
  });
  try {
    const response = await api.post('admin/create_api_configs', data);
    dispatch({
      type: "CREATE_APICONFIG_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "CREATE_APICONFIG_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}

export const updateApiConfigs = (api_config) => async (dispatch) => {
  
  let data = {};
  data.target_api = api_config;
  dispatch({
    type: "UPDATE_APICONFIG_REQUESTED"
  });
  try {
    const response = await api.post('admin/update_api_configs', data);
    dispatch({
      type: "UPDATE_APICONFIG_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "UPDATE_APICONFIG_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}